/** Bind een galerij-index binnen [0, length-1]; 0 bij een lege lijst. */
export function clampIndex(index: number, length: number): number {
  if (length <= 0) return 0
  return Math.max(0, Math.min(index, length - 1))
}
